// extracted by mini-css-extract-plugin
module.exports = {"MenuItem":"menu-item_MenuItem__K48NW","ItemContent":"menu-item_ItemContent__HJbKX","DecorationContent":"menu-item_DecorationContent__xVnOT","Icon":"menu-item_Icon__CjL3c"};